import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './styles/theme';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Initialize Eruda for mobile debugging (works on iPhone Safari)
// Enable by adding ?debug=true to URL only (disabled in development by default)
if (new URLSearchParams(window.location.search).get('debug') === 'true') {
  import('eruda').then((eruda) => {
    eruda.default.init();
    console.log('🔧 Eruda mobile console enabled! Tap the floating button to open console.');
  }).catch((err) => {
    console.warn('Eruda not available:', err);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);

// Register service worker for PWA functionality
// Only register in production to avoid caching issues during development
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('App is ready to work offline!');
    },
    onUpdate: (registration) => {
      console.log('New version available! Please refresh.');
      // Optional: Show update notification to user
      if (window.confirm('New version available! Click OK to update.')) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  });
} else {
  console.log('Service Worker disabled in development mode');
  // Unregister any existing service workers in development
  serviceWorkerRegistration.unregister();
}
